<template>
  <div>
    <!--    搜索部分-->
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline " label-width="80px">
      <div class="formOne">
        <el-form-item label="手机号">
          <el-input size="medium" clearable v-model="enquiryForm.mobile_phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input size="medium" clearable v-model="enquiryForm.user_name" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input size="medium" clearable v-model="enquiryForm.real_name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="机构">
          <el-input placeholder="请选择" v-model="enquiryForm.organiza" size="medium" :disabled="true">
            <el-button slot="append" @click="mechanismSearch">选择</el-button>
          </el-input>
        </el-form-item>
      </div>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()">打印</el-button>
    </div>

    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'id', order: 'descending'}"
              v-loading="loading" border id="tableDataId" size="mini">
      <el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="user_name" label="用户名">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="real_name" label="真实姓名">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="user_account" label="用户账号">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="mobile_phone" label="手机号">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="invite_code" label="推广码">
        <template slot-scope="scope">
					<span @click="modifyCode(scope.row)" class="code"><i class="el-icon-edit">
          </i>{{ scope.row.invite_code }}</span>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="unique_identifier_no" label="用户识别码">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="creator" label="创建人">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="register_time" label="注册时间">
      </el-table-column>
      <!--      10-未认证、20-认证中、30-认证成功、40-认证失败-->
      <el-table-column header-align="center" align="center" prop="auth_status" label="实名状态">
        <template slot-scope="scope">
          <el-button size="medium" type="danger" style="font-size: 12px;" v-if="scope.row.auth_status.value == '10'"
          >{{ scope.row.auth_status.text }}
          </el-button>
          <el-button size="medium" type="danger" style="font-size: 12px;" v-if="scope.row.auth_status.value == '20'"
          >{{ scope.row.auth_status.text }}
          </el-button>
          <el-button size="medium" type="success" style="font-size: 12px;" v-if="scope.row.auth_status.value == '30'"
                     @click="modifySta(scope.row)">{{ scope.row.auth_status.text }}
          </el-button>
          <el-button size="medium" type="danger" style="font-size: 12px;" v-if="scope.row.auth_status.value == '40'"
          >{{ scope.row.auth_status.text }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
                   layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
    <!--修改推广码表单-->
    <el-dialog v-if="dialogCodeVisible" title="提示" :visible.sync="dialogCodeVisible" width="420px">
      <span>请输入新的推广码。注意：这将使用户旧推广码失效！</span>
      <el-form :model="dialogCodeData" :rules="rules" ref="ruleForm">
        <el-form-item style="margin-bottom: 17px" prop="dialogCode">
          <el-input v-model="dialogCodeData.dialogCode" autocomplete="off" style="width: 350px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCodeVisible = false">取 消</el-button>
        <el-button type="primary" @click="codeSubmitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--认证成功点击表单-->
    <el-dialog v-if="dialogStatusVisible" title="提示" :visible.sync="dialogStatusVisible" width="420px">
      <span>即将重置用户实名认证状态，是否继续？</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogStatusVisible = false">取 消</el-button>
        <el-button type="primary" @click="statusSubmitForm">确 定</el-button>
      </div>
    </el-dialog>
    <!--      机构选择表单部分-->
    <el-dialog v-if="dialogVisible" title="配置表单" :visible.sync="dialogVisible">
      <!--    搜索部分-->
      <el-form :inline="true" :model="dialogForm" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input size="medium" clearable v-model="dialogForm.user_name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="medium" clearable v-model="dialogForm.mobile_phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch1(dialogForm)">搜索
        </el-button>
        <el-button size="medium"  style="font-size: 12px;" @click="handleSearch2(dialogForm)">重置
        </el-button>
      </el-form>
      <!--    表格部分-->
      <el-table height="250" :data="dialogData" style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}" v-loading="loading1" border
                @row-click="singleElection">
        <el-table-column align="center" width="55">
          <template slot="header">
            <span style="cursor:pointer" @click="cancelClick">取消</span>
          </template>
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">{{ '&nbsp;' }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="user_name" label="代理商名称">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="mobile_phone" label="代理商手机号">
        </el-table-column>
      </el-table>
      <!-- 分页部分 -->
      <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                     :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size1" :total="dialogTotal"
                     layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- //打印 -->
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
  </div>
</template>

<script>
import {
  export_json_to_excel
} from "@/excel/Export2Excel";
import prints from '@/components/print.vue'

export default {
  name: "userInformationOne",
  components: {
    prints
  },
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      page_size: 20, //条数
      total: 0, //总数
      tableData: [], //表格数据
      enquiryForm: {
        organiza_id: '', //代理商ID
        real_name: "", //真实姓名
        user_name: "", //用户名称
        page_size: 20,
        mobile_phone: "", //手机号码
        page: 1,
        organiza: "" //代理商名称
      },
      userid: '', //修改推广码当前行user_id
      dialogCodeData: {
        dialogCode: '', //推广码修改值
      },
      rules: {
        dialogCode: [{
          required: true,
          message: '请输入推广码',
          trigger: 'blur'
        },]
      },
      // 表单部分
      loading1: true, //列表loadding
      page_size1: 20, //表单条数
      dialogTotal: 0, //表单总数
      dialogData: [], //表单数据
      dialogVisible: false, //表单页面显示
      dialogCodeVisible: false, //邀请码表单页面显示
      dialogForm: { //表单搜索数据
        page_size: 20,
        mobile_phone: "", //手机号码
        page: 1,
        user_name: "", //用户名称
      },
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      //打印
      tableTh: null,
      tableTd: null,
      dialogStatusVisible: false,
      statusId: '',
    }
  },
  created() {
    this.getData(this.enquiryForm);
    this.tableTh = ['ID', '用户名', '真实姓名', '用户账号', '手机号', '推广码', '用户识别码', '创建人', '注册时间', '实名状态'];
    this.tableTd = ['id', 'user_name', 'real_name', 'user_account', 'mobile_phone', 'invite_code', 'unique_identifier_no', 'creator', 'create_time', 'auth_statusText'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    //打印
    printEvent() {
      this.tableData.forEach(item => { //实名状态转换文本
        item.auth_statusText = item.auth_status.text;
      });
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },

    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.page = 1;
      searchForm.user_name = '';
      searchForm.organiza_id = '';
      searchForm.mobile_phone = '';
      searchForm.organiza = '';
      searchForm.real_name = '';
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/system/userList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    //修改推广码
    modifyCode(row) {
      this.dialogCodeVisible = true;
      this.dialogCodeData.dialogCode = '';
      this.userid = row.id;
    },
    // 推广码表单校验
    codeSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑确定
          this.$api.post("/api/user_center/updateInviteCode", {
            "user_id": this.userid,
            "code": this.dialogCodeData.dialogCode
          }, res => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: '操作成功',
                duration: 1000,
                onClose() {
                }
              });
              this.dialogCodeVisible = false;
              this.getData(this.enquiryForm);
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    //实名认证点击
    modifySta(row) {
      this.dialogStatusVisible = true;
      this.statusId = row.id;
    },
    //确定
    statusSubmitForm() {
      // 编辑确定
      this.$api.post("/api/user/resetUserIdentity", {
        "id": this.statusId,
      }, res => {
        if (res.status == 200) {
          this.$message.success(res.msg);
          this.dialogStatusVisible = false;
          this.getData(this.enquiryForm);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 导出
    exportData() {
      let th = ['ID', '用户名', '真实姓名', '用户账号', '手机号', '推广码', '用户识别码', '创建人', '注册时间', '实名状态'];
      let excelData = ['id', 'user_name', 'real_name', 'user_account', 'mobile_phone', 'invite_code',
        'unique_identifier_no', 'creator', 'create_time', 'auth_statusText'
      ];
      this.tableData.forEach(item => { //实名状态转换文本
        item.auth_statusText = item.auth_status.text;
      });
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 表单部分
    //表单分页
    handleCurrentChange1(page) { //当前选中页
      this.dialogForm.page = page;
      this.getDialogData(this.dialogForm);
    },
    handleSizeChange1(limit) { //表单条数
      this.dialogForm.page_size = limit;
      this.dialogForm.page = 1;
      this.getDialogData(this.dialogForm);
    },
    //表单搜索
    handleSearch1(dialogForm) {
      dialogForm.page = 1;
      this.getDialogData(dialogForm);
    },
    //表单重置
    handleSearch2(dialogForm) {
      dialogForm.page = 1;
      dialogForm.mobile_phone = '';
      dialogForm.user_name = '';
      this.getDialogData(dialogForm);
    },
    // 机构选择页面显示（表单显示）
    mechanismSearch() {
      this.dialogVisible = true;
      this.getDialogData(this.dialogForm);
    },
    //表单获取数据
    getDialogData(params) { //初始化数据
      this.loading1 = true;
      this.$api.post("/api/agent/getUserOrganiza?page=" + params.page, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal = dialogData.total; //总数
          this.dialogData = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading1 = false;
      })
    },
    //获取每行
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = row;
      // this.checkList = this.dialogData.filter((item) => item.id === row.id)
    },
    //取消
    cancelClick() {
      this.checkList = [];
      this.templateSelection = '';
    },
    // 表单确定
    submitForm() {
      this.enquiryForm.organiza = this.checkList.user_name;
      this.enquiryForm.organiza_id = this.checkList.id;
      this.handleSearch2(this.dialogForm);
      this.cancelClick();
      this.dialogVisible = false;
      this.getData(this.enquiryForm);
    },
    //表单取消
    cancelDialog() {
      this.handleSearch2(this.dialogForm);
      this.cancelClick();
      this.dialogVisible = false;

    }
  }
}
</script>
<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.code {
  cursor: pointer;
}

.code:hover {
  color: #5111ee;
  text-decoration: underline;
}

/*::v-deep .is-leaf{*/
/*  color: #000000;*/
/*  font-weight: bold;*/
/*  background-color: #e5e4e4;*/
/*}*/

</style>
